import { Reveal } from "@/components/Reveal";

const SECTIONS = [
  {
    title: "1. The Service",
    body: "RealEstateHero360 provides a monthly subscription for AI-generated real estate marketing videos. The Starter plan includes 4 videos per month (15–60 seconds each) across property tours, listings, agent testimonials, neighborhood guides, and market reports.",
  },
  {
    title: "2. Billing & Cancellation",
    body: "Billing is monthly at $2,000 per month, with no setup fees and no long-term contracts. You may cancel at any time; service continues until the end of the current billing period. No cancellation penalties apply. A full refund is available within 30 days of your first payment, no questions asked.",
  },
  {
    title: "3. Revisions",
    body: "Your first month includes unlimited revisions so we can lock in your style. From month two onward, each video includes 2 revision rounds. Additional revision rounds may be purchased on request.",
  },
  {
    title: "4. Your Rights & Content",
    body: "You retain full commercial rights to every video we produce for you, royalty-free, in perpetuity — including after cancellation. You confirm you own or have licensed the photos and assets you upload, and grant us a limited license to use them solely to produce your videos.",
  },
  {
    title: "5. Turnaround",
    body: "Our standard turnaround is 48 hours per video from a complete brief. Complex briefs or heavy revision rounds may extend this; we will always communicate timelines proactively.",
  },
  {
    title: "6. Liability",
    body: "The service is provided \"as is.\" Our total liability is limited to the fees you paid in the 3 months preceding any claim. Nothing in these terms limits rights that cannot be limited under applicable law. Questions: legal@realestatehero360.com.",
  },
];

export default function TermsPage() {
  return (
    <main className="bg-hero-cream pt-[72px]" data-testid="terms-page">
      <section className="mx-auto max-w-3xl px-4 py-20 sm:px-6 sm:py-24 lg:px-8">
        <Reveal>
          <span className="inline-block border-2 border-hero-black px-3 py-1 font-display text-sm font-semibold uppercase tracking-[0.3em] text-hero-black">
            Legal
          </span>
          <h1 className="mt-6 font-display text-4xl font-bold uppercase tracking-tight text-hero-black sm:text-5xl">
            Terms of Service
          </h1>
          <p className="mt-4 text-base text-hero-black/60">Last updated: July 2026</p>
        </Reveal>
        <div className="mt-12 space-y-10">
          {SECTIONS.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.05}>
              <h2 className="font-display text-2xl font-bold uppercase tracking-tight text-hero-black">{s.title}</h2>
              <p className="mt-3 text-base leading-relaxed text-hero-black/70">{s.body}</p>
            </Reveal>
          ))}
        </div>
      </section>
    </main>
  );
}
